/*
 * Copyright Red Hat, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * RHDH themes as NFS extensions (ThemeBlueprint).
 * Only the app can register ThemeBlueprint; we use the same theme definitions
 * from the theme plugin (getAllThemes()) so behavior matches the legacy app.
 *
 * @packageDocumentation
 */

import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';

import '../assets/fonts/font.min.css';

import { getAllThemes } from '../themes';

const rhdhThemeExtensions = getAllThemes().map(appTheme =>
  ThemeBlueprint.make({
    name: appTheme.id,
    params: {
      theme: {
        id: appTheme.id,
        title: appTheme.title,
        variant: appTheme.variant,
        icon: appTheme.icon,
        Provider: appTheme.Provider,
      },
    },
  }),
);

/*
 * @alpha
 */
export const rhdhThemeModule = createFrontendModule({
  pluginId: 'app',
  extensions: rhdhThemeExtensions,
});
